/*
 * fawn scroll-reveal.
 * - Whole-container reveal for text sections (fade + rise).
 * - Gentle cascade for grid items (category tiles, product cards): each item eases in
 *   with a soft stagger when its grid scrolls into view.
 * Hide state lives in snippets/fawn-reveal.liquid (gated on html.fawn-reveal-on).
 * Explicit selector allow-list (never a substring match); re-scans on DOM changes so
 * AJAX / theme-editor content can't get stuck hidden.
 */
(function () {
  window.__fawnRevealReady = true;

  var root = document.documentElement;
  if (!root.classList.contains('fawn-reveal-on')) return;

  if (!('IntersectionObserver' in window)) {
    root.classList.remove('fawn-reveal-on');
    return;
  }

  var WHOLE = [
    '#MainContent .ourstory__inner',
    '#MainContent .trust__inner',
    '#MainContent .faqs__inner',
    '#MainContent .nl__inner',
    '#MainContent .prose__inner',
    '#MainContent .cform__inner',
    '#MainContent .shopcat__head',
    '#MainContent .section-content-wrapper',
    '#MainContent .section-resource-list__header',
    'footer .sitefooter__inner'
  ].join(', ');

  // container selector -> child item selector (staggered)
  var CASCADES = [
    { container: '#MainContent .shopcat__grid', item: '.shopcat__tile' },
    { container: '#MainContent .section-resource-list__content', item: '.resource-list__item' }
  ];

  var STEP_MS = 90; // soft stagger between items
  var MAX_STEPS = 7; // cap so later rows never wait too long
  var seen = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

  var wholeIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        wholeIO.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  var cascadeIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var items = entry.target.querySelectorAll(entry.target.__fawnItem);
      for (var i = 0; i < items.length; i++) {
        items[i].style.transitionDelay = (Math.min(i, MAX_STEPS) * STEP_MS) + 'ms';
        items[i].classList.add('is-in');
      }
      cascadeIO.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  function scan() {
    var whole = Array.prototype.slice.call(document.querySelectorAll(WHOLE));
    whole = whole.filter(function (el) {
      for (var i = 0; i < whole.length; i++) {
        if (whole[i] !== el && whole[i].contains(el)) return false;
      }
      return true;
    });
    whole.forEach(function (el) {
      if (seen) { if (seen.has(el)) return; seen.add(el); }
      wholeIO.observe(el);
    });

    CASCADES.forEach(function (cfg) {
      var containers = document.querySelectorAll(cfg.container);
      Array.prototype.forEach.call(containers, function (c) {
        if (seen) { if (seen.has(c)) return; seen.add(c); }
        c.__fawnItem = cfg.item;
        cascadeIO.observe(c);
      });
    });
  }

  var pending = false;
  function scanSoon() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 200);
  }

  function start() {
    scan();
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scanSoon(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', scan);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
